import { render, staticRenderFns } from "./BaseAdminTableColumn.vue?vue&type=template&id=40d65c48&scoped=true&"
import script from "./BaseAdminTableColumn.vue?vue&type=script&lang=js&"
export * from "./BaseAdminTableColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d65c48",
  null
  
)

export default component.exports